export const API_URLS = {
  AUTH: {
    LOGIN_USER: "/login",
    REGISTER_USER: "/register",
    SEND_OTP_TO_MOBILE: "/sendOtpToMobile",
    MOBILE_VERIFICATION: "/mobileVerification",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    UPDATE_PASSWORD: "/update-password",
    PAGE_VISIT: "/page/visit",
    SIGN_OUT: "/signout",
    DEMO_LOGIN: "/login/demo",
  },
  USER: {
    ACCOUNT_STATEMENT: "/getAccountstatement",
    CREATE_WITHDRAW_REQUEST: "/withdrawRequest/create",
    CREATE_DEPOSIT: "/deposit/create",
    GET_WITHDRAW_LIST: "/withdrawRequest/get",
    GET_DEPOSIT_LIST: "/deposit/get",
    HPAY_DEPOST: "/deposit/hpay",
    FLOXY_DEPOSIT: "/deposit/floxy",
    GET_ALL_GATEWAYS: "/gateways",
    PLAYER_BANK_DETAILS: "/bank",
    DYNAMIC_MANUAL_WITHDRAW: "/withdrawRequest/dynamic",
    REQUEST_WITHDRAW_OTP: "/withdraw/request/otp",
  },
  APP: {
    APP_DETAILS: "/getAppDetails",
    BANK_DETAILS: "/getBankAccountDetails",
    GET_BANNERS: "/getBanners",
    GET_NOTIFICATIONS: "/announcement/display",
    GET_APP_DEMO: "/app/demo",
  },
  SPORTS: {
    PLACE_BET: "/bet/match/odds",
    GET_BET_MATCHES: "/bet/matches",
    GET_USER_BETS: "/bets",
    PLACE_FANCY_BET: "/bet/fancy/odds",
    GET_LIVE_TV_URL:
      "https://ss247.life/api/66d33b52756913b5cc220b1ae2761bb4fc874bfc/streaminfoCR.php?Type=CRICKET",
    PLACE_BOOKMAKER_BET: "/bet/bookmaker/odds",
  },
  BONUS: {
    CLAIMS: "/bonus/claims",
    STATS: "/bonus/claims/stats",
    PARTS: "/bonus/claims/parts",
    CANCEL: "/bonus/claims/cancel",
  },
  REFERRAL: {
    GENERATE: "/ref/generate",
    STATS: "/ref/stats",
    CHILDREN: "/ref/children",
    SOURCES: "/ref/sources",
  },
};
